import { Component, OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { CommonService } from "../services/common.service";

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.scss"],
})
export class ForgotPasswordComponent implements OnInit {
  constructor(private _common: CommonService) {}

  emailControl: FormControl = new FormControl("", [
    Validators.required,
    Validators.email,
  ]);
  alertText: string;
  alertClass: string;
  submitted: boolean = false;
  apiResponse: boolean = false;

  ngOnInit(): void {}

  onSubmit(): void {
    this.submitted = true;
    if (this.emailControl.valid) {
      const data = {
        email: this.emailControl.value,
      };
      this._common.post(`v1/forgotPassword`, data).subscribe(
        (resp: any) => {
          if (resp.success) {
            this.alertClass = "success";
            this.alertText = resp.message;
            this.submitted = false;
            this.emailControl.reset();
            this.apiResponse = true;
          }
        },
        (err) => {
          this.alertClass = "error";
          this.alertText = err.error.message;
          this.apiResponse = true;
        }
      );
    }
  }
}
